// extracted by mini-css-extract-plugin
module.exports = {"containerInner":"LandingDonation_containerInner__2_J3z","description":"LandingDonation_description__1DVqk"};